import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import useOnclickOutside from "react-cool-onclickoutside";
import { Context } from '../context/AuthContext';

const NavLink = (props) => {
  return <Link {...props} />;
};

const Navbar = () => {
  const { handleLogout } = useContext(Context);  
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  const useDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
      setIsOpen((prevIsOpen) => !prevIsOpen);
    };

    const closeDropdown = () => {
      setIsOpen(false);
    };

    const ref = useRef(null);
    useOnclickOutside(() => {
      closeDropdown();
    }, ref);

    return {
      isOpen,
      toggleDropdown,
      closeDropdown,
      ref,
    };
  };

const { isOpen: openMenu, toggleDropdown: handleBtnClick, closeDropdown: closeMenu, ref } = useDropdown();
const { isOpen: openMenu1, toggleDropdown: handleBtnClick1, closeDropdown: closeMenu1, ref: ref1 } = useDropdown();
const { isOpen: openMenu2, toggleDropdown: handleBtnClick2, closeDropdown: closeMenu2, ref: ref2 } = useDropdown();
const { isOpen: openMenu3, toggleDropdown: handleBtnClick3, closeDropdown: closeMenu3, ref: ref3 } = useDropdown();
const { isOpen: openMenu4, toggleDropdown: handleBtnClick4, closeDropdown: closeMenu4, ref: ref4 } = useDropdown();

  const [showmenu, setBtnIcon] = useState(false);

  useEffect(() => {
    const header = document.getElementById("header-wrap");
    const totop = document.getElementById("scroll-to-top");
    const sticky = header.offsetTop;

    const scrollCallBack = () => {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
        totop.classList.add("show");
      } else {
        header.classList.remove("sticky");
        totop.classList.remove("show");
      }
    };

    window.addEventListener("scroll", scrollCallBack);

    return () => {
      window.removeEventListener("scroll", scrollCallBack);
    };
  }, []);

  const { 
    isOpen: openLoginMenu, 
    toggleDropdown: handleLoginClick, 
    closeDropdown: closeLoginMenu, 
    ref: refLogin 
  } = useDropdown();

  const { 
    isOpen: openEventoMenu, 
    toggleDropdown: handleEventoClick, 
    closeDropdown: closeEventoMenu, 
    ref: refEvento 
  } = useDropdown();

  const { 
    isOpen: openDocumentoMenu, 
    toggleDropdown: handleDocumentoClick, 
    closeDropdown: closeDocumentoMenu, 
    ref: refDocumento 
  } = useDropdown();
  
  return (
    <nav className="navbar transition">
        <div className="container">

          {/********* Logo *********/}
          <NavLink  className="navbar-brand" to="/">
            <img src="../img/logo.png" width="80" className="img-fluid d-md-block d-none imginit" alt="Fetron"/>
            <img src="../img/logo-mobile.png" width="80"className="img-fluid d-md-none d-sms-none imginit" alt="Fetron"/>
          </NavLink>
          {/********* Logo *********/}

              {/********* Mobile Menu *********/}
              <div className="mobile">
                {showmenu && 
                <div className='menu'>

                   <div className='navbar-item'>
                      <NavLink to="/">
                        Início
                      </NavLink>
                    </div>

                    <div className='navbar-item'>
                      <NavLink to="/quem-somos">
                        A Fetron
                      </NavLink>
                    </div>

                    <div className='navbar-item counter'>
                      <NavLink to="/academias">
                        Academias
                      </NavLink>
                    </div>

                    <div className='navbar-item counter'>
                      <NavLink to="/materiais-de-estudo">
                        Materiais de estudo
                      </NavLink>
                    </div>

                    <div className='navbar-item counter' ref={refDocumento}>
                      <NavLink to="/documentos">
                        Documentos
                      </NavLink>
                      {openDocumentoMenu && (
                        <div className="submenu submenu-mobile">
                          <NavLink to="/documentos/ATAS">ATAS</NavLink>
                          <NavLink to="/documentos/CIRCULAR">CIRCULAR</NavLink>
                          <NavLink to="/documentos/CONVOCAÇÕES">CONVOCAÇÕES</NavLink>
                          <NavLink to="/documentos/EDITAL">EDITAL</NavLink>
                          <NavLink to="/documentos/ESTATUTO">ESTATUTO</NavLink>
                          <NavLink to="/documentos/REGULAMENTOS">REGULAMENTOS</NavLink>
                        </div>
                      )}
                    </div>

                    <div className='navbar-item counter' ref={refEvento}>
                      <NavLink to="/eventos">Eventos Fetron</NavLink>
                    </div>
                    
                    <div className='navbar-item counter' ref={refEvento}>
                      <NavLink to="/eventos-passados">Eventos Realizados</NavLink>
                    </div>

                    <div className='navbar-item counter' ref={refEvento}>
                      <NavLink to="/cursos-seminarios">Cursos / Seminários</NavLink>
                    </div>

                    <div className='navbar-item counter' ref={refEvento}>
                      <NavLink to="/exames">Exames</NavLink>
                    </div>

                    <div className='navbar-item counter'>
                      <NavLink to="/noticias">
                        Notícias
                      </NavLink>
                    </div>

                    <div className='navbar-item counter' ref={refLogin}>
                      <NavLink to="#" onClick={handleLoginClick}>
                        Login
                      </NavLink>
                      {openLoginMenu && (
                        <div className="submenu submenu-mobile">
                          <NavLink to="/login">Acesso Atleta</NavLink>
                          <a href="https://app.fetron.com.br" target="_blank" rel="noopener noreferrer">Acesso Academia</a>
                        </div>
                      )}
                    </div>
                    {user &&
                      <>
                        <div className='navbar-item counter'>
                          <NavLink to="/meu-painel">
                            Meu Painel
                          </NavLink>
                        </div>
                        <div className='navbar-item counter'>
                          <NavLink onClick={() => handleLogout()} to="/">
                            Logout
                          </NavLink>
                        </div>
                        </>
                    }
                </div>
                }
          </div>
          {/********* Mobile Menu *********/}

          {/********* Dekstop Menu *********/}
          <div className="dekstop">
            <div className='menu'>

              <div className='navbar-item'>
                <NavLink to="/">
                  Início
                </NavLink>
              </div>

              <div className='navbar-item'>
                <NavLink to="/quem-somos">
                  A Fetron
                </NavLink>
              </div>

              <div className='navbar-item counter'>
                <NavLink to="/academias">
                  Academias
                </NavLink>
              </div>

              <div className='navbar-item counter'>
                <NavLink to="/materiais-de-estudo">
                  Materiais de Estudo
                </NavLink>
              </div>

              <div className='navbar-item counter' ref={refDocumento}>
                <NavLink to="/#" onClick={handleDocumentoClick}>
                  Documentos
                </NavLink>
                {openDocumentoMenu && (
                  <div className="submenu">
                    <NavLink to="/documentos/ATAS">ATAS</NavLink>
                    <NavLink to="/documentos/CIRCULAR">CIRCULAR</NavLink>
                    <NavLink to="/documentos/CONVOCAÇÕES">CONVOCAÇÕES</NavLink>
                    <NavLink to="/documentos/EDITAL">EDITAL</NavLink>
                    <NavLink to="/documentos/ESTATUTO">ESTATUTO</NavLink>
                    <NavLink to="/documentos/REGULAMENTOS">REGULAMENTOS</NavLink>
                  </div>
                )}
              </div>

              <div className='navbar-item counter' ref={refEvento}>
                <NavLink to="#" onClick={handleEventoClick}>
                  Eventos
                </NavLink>
                {openEventoMenu && (
                  <div className="submenu">
                    <NavLink to="/eventos">Eventos Fetron</NavLink>
                    <NavLink to="/eventos-passados">Eventos Realizados</NavLink>
                    <NavLink to="/cursos-seminarios">Cursos / Seminários</NavLink>
                    <NavLink to="/exames">Exames</NavLink>
                  </div>
                )}
              </div>

              <div className='navbar-item counter'>
                <NavLink to="/noticias">
                  Notícias
                </NavLink>
              </div>

              {!user &&
                <div className='navbar-item counter' ref={refLogin}>
                  <NavLink to="#" onClick={handleLoginClick}>
                    Login
                  </NavLink>
                  {openLoginMenu && (
                    <div className="submenu">
                      <NavLink to="/login">Acesso Atleta</NavLink>
                      <a href="https://app.fetron.com.br" target="_blank" rel="noopener noreferrer">Acesso Academia</a>
                    </div>
                  )}
                </div>
              }

              {user &&
                <>
                  <div className='navbar-item counter'>
                    <NavLink to="/meu-painel">
                      Meu Painel
                    </NavLink>
                  </div>

                  <div className='navbar-item counter'>
                    <NavLink onClick={() => handleLogout()} to="/">
                      Logout
                    </NavLink>
                  </div>
                </>
              }
            </div>
          </div>
          {/********* Dekstop Menu *********/}

          {/********* Side Button *********/}
          <div className="menu_side_area">
              {/********* Burger Button *********/}
              <button className="burgermenu" type="button" 
                onClick={() => {
                  setBtnIcon(!showmenu);
                  closeMenu1();
                  closeMenu2();
                  closeMenu3();
                  closeMenu4();
                }}>
                <i className="fa fa-bars" aria-hidden="true"></i>
              </button>
              {/********* Burger Button *********/}
          </div>
          {/********* Side Button *********/}

          

        </div>
      </nav>
    )
}

export default Navbar;